<template>
  <div>
    <!-- add Link -->
    <base-modal
      id="add-link"
      ref="addLink"
      :show="show"
      @closed="close()"
    >
      <div class="py-2 px-3">
        <base-heading :level="2">
          Add link
        </base-heading>

        <div class="box-gray">
          <input
            v-model="url"
            type="text"
            class="form-control"
            placeholder="Enter URL link"
            @keypress.enter="submit()"
          >
        </div>
        <base-text
          v-if="url && !validateString(url)"
          light
          size="m"
          muted
        >
          The link you’ve added has no click-through destination. Please double-check it and try again.
        </base-text>

        <div class="d-flex pt-3">
          <base-button
            inverse
            class="ml-auto mr-0"
            :disabled="!validateString(url)"
            @click="submit()"
          >
            Confirm
          </base-button>
        </div>
      </div>
    </base-modal>
  </div>
</template>

<script>
export default {
  name: 'AddLinkModal',
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    url: '',
    show: false,
  }),
  watch: {
    show(newval) {
      this.$emit('link-modal-changed', newval);
    },
  },
  methods: {
    encodeUrlParameters(url) {
      const urlParts = url.split('?');

      // If there are no parameters, return the URL as is
      if (urlParts.length === 1) {
        return url;
      }

      const baseUrl = urlParts[0];
      const queryParams = new URLSearchParams(urlParts[1]);

      // URL encode each query parameter
      // eslint-disable-next-line
      for (const [key, value] of queryParams.entries()) {
        queryParams.set(key, encodeURIComponent(value));
      }

      // Return the URL with encoded query parameters
      // eslint-disable-next-line
      return baseUrl + '?' + queryParams.toString();
    },
    open() {
      this.url = this.value;
      this.show = true;
    },
    close() {
      this.show = false;
    },
    submit() {
      this.$emit('input', this.url);
      this.close();
    },
    validateString(url) {
      const updated_url = url;
      return (this.$options.methods.isURL(updated_url)
      || this.$options.methods.isEmail(updated_url)
      || this.$options.methods.isiMessage(updated_url)
      || this.$options.methods.isSMS(updated_url)
      || this.$options.methods.isValidMailtoUrl(updated_url)
      || url === '');
    },
  },
};
</script>

<style lang="scss" scoped>
.box-gray{
    padding: 1rem;
    background-color: $gray-light;
    margin-bottom: 0.5rem;
}
</style>
